module.exports = __webpack_public_path__ + "img/267.592040ff.png";